module.exports = __webpack_public_path__ + "static/media/documentation.b7f632af.md";